// src/components/common/AlertContainer/AlertContainer.jsx
import React from 'react';
import { 
  CheckCircle, 
  XCircle, 
  AlertTriangle, 
  Info, 
  X, 
  AlertCircle 
} from 'lucide-react';
import { useAlert } from '../../../contexts/AlertContext';
import styles from './AlertContainer.module.css';

const AlertContainer = () => {
  const { alerts, removeAlert } = useAlert();

  if (alerts.length === 0) return null;

  const getAlertIcon = (type) => {
    switch (type) {
      case 'success':
        return <CheckCircle size={20} />;
      case 'error':
        return <XCircle size={20} />;
      case 'warning':
        return <AlertTriangle size={20} />;
      case 'confirm':
        return <AlertCircle size={20} />;
      default:
        return <Info size={20} />;
    }
  };

  const handleAction = (action, alertId) => {
    if (action.onClick) {
      action.onClick();
    } else {
      removeAlert(alertId);
    }
  };

  return (
    <div className={styles.alertContainer}>
      {alerts.map((alert) => (
        <div
          key={alert.id}
          className={`${styles.alert} ${styles[alert.type]}`}
          role="alert"
          aria-live="polite"
        >
          <div className={styles.alertContent}>
            <div className={styles.alertIcon}>
              {getAlertIcon(alert.type)}
            </div>
            
            <div className={styles.alertText}>
              {alert.title && (
                <div className={styles.alertTitle}>{alert.title}</div>
              )}
              <div className={styles.alertMessage}>{alert.message}</div>
            </div>

            {alert.closable && alert.type !== 'confirm' && (
              <button
                className={styles.closeButton}
                onClick={() => removeAlert(alert.id)}
                aria-label="Close alert"
              >
                <X size={16} />
              </button>
            )}
          </div>

          {alert.actions && alert.actions.length > 0 && (
            <div className={styles.alertActions}>
              {alert.actions.map((action, index) => (
                <button
                  key={index}
                  className={`${styles.actionButton} ${styles[action.type || 'secondary']}`}
                  onClick={() => handleAction(action, alert.id)}
                >
                  {action.label}
                </button>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default AlertContainer;